import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../../modal/Modal';
import { BUTTON_CONSTANTS, MARKETPLACE_CONSTANTS, PAYMENT_CONSTANTS } from '../../../constants/common';
import { ROUTE_PATHS } from '../../../constants/routePaths';
import './stripePayoutReviewModal.scss';

type StripePayoutReviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const StripePayoutReviewModal: FC<StripePayoutReviewModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const goToPayoutMethod = () => {
    onClose();
    navigate(ROUTE_PATHS.APP_ACCOUNT_SETTINGS, { state: { activeTab: 3, payoutTab: 1 } });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={520} ignoreBackdrop>
      <div className="stripe-payout-review-modal">
        <div className="header">
          <h4>{PAYMENT_CONSTANTS.PAYMENT_INFORMATION}</h4>
        </div>
        <div className="body">
          <p>{MARKETPLACE_CONSTANTS.STRIPE_PAYOUT_PENDING_VERIFICATION}</p>
          <p>
            {MARKETPLACE_CONSTANTS.STRIPE_PAYOUT_CHECK_VERIFICATION_STATUS}
            <button type="button" className="stripe-payout-review-modal__link" onClick={goToPayoutMethod}>
              {PAYMENT_CONSTANTS.PAYOUT_METHOD}
            </button>
            .
          </p>
        </div>
        <div className="footer">
          <button type="button" className="button medium green" onClick={onClose}>
            {BUTTON_CONSTANTS.OK}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default StripePayoutReviewModal;
